export const Precipitation = () => (
	<div className="flex flex-col gap-4 md:gap-6 p-4 md:p-6">
		<header className="flex items-center justify-between">
			<h1 className="text-2xl md:text-4xl font-semibold tracking-tight">Precipitation</h1>
		</header>
		<section className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
			<p className="col-span-full text-muted-foreground text-sm italic">Information coming soon.</p>
		</section>
	</div>
);
